import { Component } from 'react';

// React class component that catches render-time errors anywhere below it
// and shows a minimal fallback. Logged once per boundary to avoid noise.
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[boda] ErrorBoundary caught', error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const message = this.state.error?.message ?? 'Algo se rompio.';
    return (
      <div
        role="alert"
        className="mx-auto my-12 max-w-md rounded-lg border border-error bg-bg p-6 text-center"
      >
        <h2 className="mb-2 font-heading text-xl text-error">Algo se rompio</h2>
        <p className="mb-4 text-sm text-text-muted">{message}</p>
        <button
          type="button"
          onClick={this.reset}
          className="rounded border border-border px-4 py-2 text-sm hover:border-accent hover:text-accent"
        >
          Reintentar
        </button>
      </div>
    );
  }
}
